import { render, staticRenderFns } from "./RequestsAddButton.vue?vue&type=template&id=0d201275"
import script from "./RequestsAddButton.vue?vue&type=script&lang=js"
export * from "./RequestsAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports